<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      <van-icon
          class="header-exit"
          :name="require('@/assets/icons/icon_settings_exit.png')"
          size="30"
          v-if="false"
          @click="onClickSignOut"
      />
    </div>
    <div class="profile">
      <div class="avatar-content">
        <Avatar show-icon/>
        <span>{{ userInfo.username }}</span>
      </div>
    </div>

    <div class="menu-items m-4">
      <van-cell style="padding-top:9px;padding-bottom:9px;" class="radius-border" v-for="(item,index) in menuItems"
          :key="index" is-link
          @click="item.func">
        <template #icon>
          <van-image class="icon" :src="item.icon"/>
        </template>
        <template #title>
          <span class="title">{{ item.title }}</span>
        </template>
      </van-cell>
    </div>

    <DialogTips v-model="showTips" :show-left="showLeft"
        show-right
        :title="tipsTitle"
        :message="tipsMessage"
        :left-text="leftText"
        :right-text="rightText"
        :align="textAlign"
        @onLeftClick="leftClick"
        @onRightClick="rightClick"/>

    <!-- Account Popup -->
    <van-popup
        class="account-popup"
        v-model="showAccountPopup"
        round
        :close-on-click-overlay="false"
    >
      <div class="popup-header">
        Account
        <img src="@/assets/icons/icon_close.png" @click="onClickClose"/>
      </div>
      <div class="popup-content">
        <div class="title">Email Address</div>
        <div class="info">
          {{ userInfo.username }}
          <!--<img src="@/assets/icons/icon_edit.png" alt="" @click="onClickEdit" />-->
        </div>
        <div class="title">Password</div>
        <div class="info">
          ●●●●●●●●
          <!--<img src="@/assets/icons/icon_edit.png" alt="" @click="onClickEdit" />-->
        </div>
      </div>
      <div class="popup-button" @click="onClickSignOut">Sign Out</div>
    </van-popup>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import login from "./Login.vue";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import { TOKEN } from "@/config/http-json";
import bus from "@/util/EventBus";
import { Toast } from "vant";
import user from "@/api/user";
import Avatar from "@/components/profile/Avatar.vue";

import log from "@/util/log";
import DialogTips from "@/components/DialogTips.vue";

export default {
  name: "AppSettings",
  components: { DialogTips, Avatar },
  data() {
    return {
      showAccountPopup: false,
      userAvatar: null,
      showTips: false,
      tipsTitle: "",
      tipsMessage: "",
      leftClick: () => this.showTips = false,
      rightClick: ()=> {},
      showLeft: true,
      showRight: true,
      leftText: "",
      rightText: "",
      textAlign: 'text-center'
    };
  },
  methods: {
    ...mapActions(["_setLoginInfo"]),
    onClickHeaderReturn() {
      this.$router.go(-1);
    },

    onClickClose() {
      this.showAccountPopup = false;
    },

    onClickSignOut() {
      this.textAlign = 'text-center'
      this.showLeft = true;
      this.showTips = true;
      this.tipsTitle = "Tips";
      this.leftText = 'Cancel'
      this.rightText = 'Logout'

      this.tipsMessage = "Reset App back to default?";
      this.rightClick = () => {
        this.showTips = false;
        bluetoothRepository.disconnect();
        window.localStorage.setItem(TOKEN, "");
        window.localStorage.setItem("omni-user", null);
        this._setLoginInfo(null);
        this.showAccountPopup = false;
        this.$router.replace({ name: "Login", query: { hash: this.$store.state.hash } });
      };
    },

    async onClickReset() {
      this.textAlign = 'text-center'
      this.showLeft = true;
      this.showTips = true;
      this.leftText = 'Cancel'
      this.rightText = 'Apply'
      this.tipsTitle = "Tips";
      this.tipsMessage = "Reset App back to default?";
      this.leftClick = ()=> {
        this.showTips = false
      }
      this.rightClick = async () => {
        this.showTips = false;

        await this.$store.dispatch("resetApp");
        if (bus._events.resetAppNFC) {
          bus.$emit("resetAppNFC", false, () => {
            if (bus._events.resetAppBt) {
              bus.$emit("resetAppBt", false, () => {
                Toast.success("Reset success!");
              }, () => {
                Toast.success("Reset fail!");
              });
            } else {
              Toast.success("Reset success!");
            }
          }, () => {
            Toast.success("Reset fail!");
          });
        } else if (bus._events.resetAppBt) {
          bus.$emit("resetAppBt", false, () => {
            if (bus._events.resetAppNFC) {
              bus.$emit("resetAppNFC", false, () => {
                Toast.success("Reset success!");
              }, () => {
                Toast.success("Reset fail!");
              });
            } else {
              Toast.success("Reset success!");
            }
          }, () => {
            Toast.success("Reset fail!");
          });
        }
      };
    },
    onClickClearCache() {
      this.textAlign = 'text-center'
      this.showLeft = true;
      this.showTips = true;
      this.showLeft = true;
      this.tipsTitle = "Tips";
      this.leftText = 'Cancel'
      this.rightText = 'Apply'
      this.tipsMessage = "Clear cache that may be exit the currently logged in account and reset app";
      this.leftClick = ()=> {
        this.showTips = false
      }

      this.rightClick = async () => {
        window.clearAppCache([
          "WKWebsiteDataTypeDiskCache",
          "WKWebsiteDataTypeMemoryCache",
          "WKWebsiteDataTypeOfflineWebApplicationCache",
          "WKWebsiteDataTypeCookies"
        ]);
      };
    },
    async onClickVersion() {
      this.textAlign = 'text-center'
      this.showTips = true;
      this.tipsTitle = "App Version";
      this.tipsMessage = "3.0";
      this.showLeft = false;

      this.rightText = 'OK'

      this.rightClick = async () => {
        this.showTips = false
      }

      // this.$dialog
      //     .alert({
      //       title: "App Version",
      //       message: "2.0.0",
      //       confirmButtonText: "Close"
      //     });
    },
    async onClickAbout() {
      this.textAlign = 'text-left'
      this.showTips = true;
      this.tipsTitle = "About us";
      this.tipsMessage = "OMNI is a technical service system designed to enhance flexibility, customizability, compliance to regulations, and efficiency. Whether in the R&D, marketing, or manufacturing process, it provides businesses with a full-spectrum and success-oriented end-to-end solution.";
      this.showLeft = false;
      this.rightText = 'OK'

      this.rightClick = async () => {
        this.showTips = false
      }

      // this.$dialog
      //     .alert({
      //       title: "About",
      //       message: "Omni App",
      //       confirmButtonText: "Close"
      //     });
    },
    selectImage() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = async e => {
        const file = e.target.files[0];
        if (file) {
          const selectedImage = URL.createObjectURL(file);
          try {

            const formData = new FormData();
            formData.append("file", file);
            Toast.loading("Uploading");
            const resp = await user.uploadFile(formData);
            log(resp);
            if (resp.code !== 200) {
              Toast.fail(resp.message);
            } else {
              const avatarUrl = resp.data;
              if (resp.code !== 200) {
                Toast.fail(resp.message);
              } else {
                await user.updateUserProfile({ picture: avatarUrl });
                const userInfo = { ...this.loginInfo };
                userInfo.picture = avatarUrl;
                await this._setLoginInfo(userInfo);
                this.userAvatar = selectedImage;
              }

            }

          } catch (err) {
            Toast.fail("Upload avatar fail!" + err);
          }
        }
      };
      input.click();
    }

  },
  computed: {
    ...mapState("user", ["userInfo"]),
    menuItems() {
      const defaultItems = [
        {
          icon: require("@/assets/icons/v2/profile/icon_reset.png"),
          title: "Reset",
          func: this.onClickReset
        },
        {
          icon: require("@/assets/icons/v2/profile/icon_clear_cache.png"),
          title: "Clear Cache",
          func: this.onClickClearCache
        },
        {
          icon: require("@/assets/icons/v2/profile/icon_version.png"),
          title: "Version",
          func: this.onClickVersion
        },
        {
          icon: require("@/assets/icons/v2/profile/icon_about_us.png"),
          title: "About Us",
          func: this.onClickAbout
        },
        {
          icon: require("@/assets/icons/v2/profile/icon_edit_personal_info.png"),
          title: "Edit Personal Info",
          func: () => {
            this.$router.push('/profile')
          }
        },
        {
          icon: require("@/assets/icons/v2/profile/icon_clear_person_data.png"),
          title: "Clear Personal Data",
          func: this.onClickReset
        },
        {
          icon: require("@/assets/icons/v2/profile/icon_reset_password.png"),
          title: "Reset Password",
          func: () => {
            this.$router.push('/reset-password')
          }
        }
      ];
      if (!window.clearAppCache) {
        defaultItems.splice(1, 1);
      }
      return defaultItems;
    }
  },
  mounted() {
    this.userAvatar = this.userInfo.picture;
  }
};
</script>

<style scoped lang="less">
.container {
  height: 100%;
  background: #FFFFFF;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: bold;
    color: #545554;

    .header-return {
      position: absolute;
      left: 10px;
    }

    .header-exit {
      position: absolute;
      right: 10px;
    }
  }

  .profile {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .avatar-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 110px;
      height: 110px;
      color: #999999;

    }

    .username {
      font-size: 16px;
      margin-top: 12px;
      color: #939598;
    }
  }

  .menu-items {
    & > * + * {
      margin-top: 8px;
    }

    .icon {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }

    .title {
      font-size: 17px;
      color: #333333;
    }
  }
}


.account-popup {
  width: 90%;

  .popup-header {
    font-size: 21px;
    font-weight: normal;
    color: #6d6e71;
    display: flex;
    align-items: center;
    padding: 20px 20px 48px 28px;

    img {
      margin-left: auto;
      width: 28px;
      height: 28px;
    }
  }

  .popup-content {
    display: flex;
    flex-direction: column;
    padding: 0 20px 0 28px;

    .title {
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: normal;
      color: #a7a9ac;
    }

    .info {
      font-size: 18px;
      font-weight: normal;
      color: #808285;
      display: flex;
      align-items: center;
      margin-bottom: 33px;

      img {
        margin-left: auto;
        margin-right: 3px;
        width: 19px;
        height: 19px;
      }
    }
  }

  .popup-button {
    margin: 62px 25px 27px 25px;
    height: 45px;
    line-height: 45px;
    background: var(--themeMainColor);
    border-radius: 8px;
    text-align: center;
    font-size: 21px;
    font-weight: bold;
    color: #ffffff;
    transition: opacity 0.2s;
    -webkit-appearance: none;
  }

  .popup-button:active {
    opacity: 0.8;
    -webkit-tap-highlight-color: transparent;
  }
}

.van-cell {
  &:after {
    border: none;
  }
}

.van-cell__right-icon {
  color: #CCCCCC;
}
</style>